import FlexBox from '@/atomic-components/FlexBox';
import { IOfferData } from '@/components/ProductDisplayPage/model';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CrossIcon from '../../../../../assets/pdp/crossIcon.svg';
import ApplyOfferTile from './applyOfferTile';

type IOfferListProps = {
	offers: IOfferData;
	openAllOffers: boolean;
	setOpenAllOffers: Function;
	addEvents: (eventType: string, expiryText?: string) => void;
};

const OfferList = (props: IOfferListProps) => {
	const offers = props?.offers?.data?.offers;

	return (
		<Drawer
			anchor='right'
			open={props.openAllOffers}
			onClose={() => props.setOpenAllOffers(false)}
		>
			<FlexBox direction='column' sx={{ padding: '80px' }}>
				<FlexBox sx={{ justifyContent: 'space-between' }}>
					<LencoTypography sx={{ ...getStyle('H11_Medium') }}>
						Offers and Discounts
					</LencoTypography>
					<Box
						onClick={() => props.setOpenAllOffers(false)}
						sx={{ cursor: 'pointer' }}
					>
						<CrossIcon />
					</Box>
				</FlexBox>
				<LencoTypography sx={{ color: getColor('Gray 0') }}>
					Offers for you
				</LencoTypography>
				<FlexBox direction='column'>
					<ApplyOfferTile
						offers={offers}
						addEvents={(eventType: string, expiryText?: string) =>
							props?.addEvents(eventType, expiryText)
						}
					/>
				</FlexBox>
			</FlexBox>
		</Drawer>
	);
};

export default OfferList;
